<template>
  <div class="promptPopups">
    <div class="promptPopups-main">
      <!-- 标题 -->
       <div class="pro-title">
        {{popupData.title}}
       </div>
       <!-- 关闭按钮 -->
        <img
            class="pro-modal-close"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
            @click="closePromptPopups"
          />
        <!-- 文本内容区域 -->
         <div class="text-wrapper" v-html="popupData.content">
         </div>
         <!-- 单选框区域 -->
          <div class="radio-wrapper" v-if="isShowCompanyConfirmFn">

            <div class="radio-wrapper-text">
              <RcclCheckBox
              :title="'我已阅读并同意企业合作伙伴条款须知'"
              :defaultChecked="false"
              v-on:onChanged="checkIsCommonGuest"
              />
            </div>
          </div>

          <!-- 确定按钮 -->
           <div class="btn-box" @click="submitFn" v-if="isShowCompanyConfirmFn">
            确认
           </div>
          
    </div>
  </div>
</template>
<script>

const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
export default {
  
  props: {
    
    isShowCompanyConfirmFn: {
      type: Boolean,
      default() {
        return false
      }
    },
    popupData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    RcclCheckBox
  },
  data() {
    return {
      isCommonUseContact:false
    }
  },
  
  computed: {},
  methods: {
    // 提交
    submitFn(){
      if(this.isCommonUseContact == false){
         this.$alert.show('请点击及我已阅读并同意企业合作伙伴条款须知')
        return
      }
      this.$emit('submitFn')
    },
    closePromptPopups() {
      // console.log('closePromptPopups1111111')
      this.$emit('closePromptPopups')
    },
    headCallPrompt() {
      this.$emit('headCallPrompt')
    },

    checkIsCommonGuest(){
      this.isCommonUseContact = !this.isCommonUseContact
    }
  }
}
</script>
<style scoped lang="less">
.promptPopups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.34);
  /* padding: 0 74rpx; */

  .promptPopups-main {
    width: 720px;
    // min-height: 900px;
    background: #FFFFFF;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
    //border-radius: 16px;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    padding: 40px 30px 30px 30px;

    .pro-title{
      font-weight: 400;
      font-size: 35px;
      color: #005AA3;
      line-height: 53px;
      text-align: left;
      font-style: normal;
      text-align: center;
      margin-bottom: 20px;
    }

    .pro-modal-close{
      position: absolute;
      width: 32px;
      top: 20px;
      right: 30px;
      z-index: 2;
      cursor: pointer;
    }

    .text-wrapper{
      width: 100%;
      max-height: 600px;
      background: #F1F1F1;
      overflow-y: auto;
      scrollbar-color: #FCC300 #F1F1F1;
      // font-weight: 400;
      // font-size: 22px;
      // color: #000000;
      // line-height: 33px;
      // text-align: left;
      // font-style: normal;
      padding: 16px;
      
    }

    .radio-wrapper{
      display: flex;
      margin-bottom: 18px;
      margin-top: 18px;
    }

    .radio-wrapper-text{
      font-weight: 400;
      font-size: 16px;
      color: #1E2A32;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }

    .btn-box{
      width: 100%;
      height: 56px;
      background: #FCC300;
      border-radius: 12px;
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 56px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
    }
    
  }
}
</style>
